import {BleDevice} from "../protocol/ble";
import {DeviceEvent} from "@hybird/core/device/protocol";
import {config} from "../config";
import {WebError} from "@hybird/core/error";
import {deviceError} from "@hybird/device/deviceError";

class WebBluetoothDevice extends BleDevice {
  readCharacteristic;

  /**
   *
   * @type {BluetoothRemoteGATTCharacteristic[]}
   */
  writeCharacteristic = [];

  /**
   * @type BluetoothDevice
   */
  peripheral;

  async _connect({clear, resolve, reject}) {
    try {
      this.readCharacteristic = null;
      this.writeCharacteristic = [];

      const device = this.peripheral = await navigator.bluetooth.requestDevice({
        filters: [{
          name: this.name
        }], // 替换为你的服务UUID
        optionalServices: this.serviceUUIDs
      });

      const bluetoothRemoteGATTServerPromise = await device.gatt.connect();

      clear(() => {
        bluetoothRemoteGATTServerPromise.disconnect();
      })

      device.addEventListener("gattserverdisconnected", (ev) => {
        console.log("蓝牙断开连接", ev)
        this.emit(DeviceEvent.DISCONNECTED);
        this.peripheral = null;
      })

      const services = await bluetoothRemoteGATTServerPromise.getPrimaryServices();

      let characteristicUUIDs = {};
      if (this.characteristicUUIDs instanceof Array) {
        for (let i in this.characteristicUUIDs) {
          characteristicUUIDs[this.characteristicUUIDs[i]] = "read";
        }
      } else {
        Object.assign(characteristicUUIDs, this.characteristicUUIDs);
      }

      for (const i in services) {
        const service = services[i];
        if (this.serviceUUIDs.find(s => service.uuid.startsWith(s))) {
          const characteristics = await service.getCharacteristics();

          for (const j in characteristics) {
            const characteristic = characteristics[j];
            const uuid = characteristic.uuid;
            console.log(uuid);

            if (characteristicUUIDs[uuid] === "read" && characteristic.properties.notify) {
              await characteristic.startNotifications();

              characteristic.addEventListener("characteristicvaluechanged", event => {
                const decoder = new TextDecoder();
                const newValue = decoder.decode(event.target.value);
                this._onMessage(newValue);
              });

              this.readCharacteristic = characteristic;
            } else if (characteristicUUIDs[uuid] === "write") {
              this.writeCharacteristic.push(characteristic);
            }
          }
        }
      }

      if (!this.readCharacteristic) {
        reject(WebError.code(deviceError.CONNECT_ILLEGAL_ARGUMENT, {msg: "该设备无法使用蓝牙连接"}));
      }

      if (this.writeCharacteristic.length === 0) {
        if (this.readCharacteristic) {
          this.writeCharacteristic.push(this.readCharacteristic);
        } else {
          reject(WebError.code(deviceError.CONNECT_ILLEGAL_ARGUMENT));
        }
      }


      resolve();
    } catch (e) {
      if (e.message?.includes("User cancelled the requestDevice() chooser.")) {
        reject(WebError.error(e, deviceError.BLE_CANCEL));
      }

      reject(WebError.error(e, deviceError.CONNECT_ERROR));
    }
  }

  async _write({clear, buffer, resolve, reject}) {
    let send = false;

    for (let i = 0; i < 3; i++) {
      for (const i in this.writeCharacteristic) {
        try {
          await this.writeCharacteristic[i].writeValue(buffer);
          send = true;
          break;
        } catch (e) {
          console.error("ble write error", e);
        }
      }

      if (send) {
        resolve();
        return;
      }
    }

    reject(WebError.error(deviceError.WRITE_TIMEOUT));
  }

  get state() {
    return this.peripheral?.gatt?.connected ? "connected" : "disconnected";
  }

  get connected() {
    return this.peripheral?.gatt?.connected;
  }

  async _disconnect() {
    if (this.peripheral?.gatt?.connected) {
      this.peripheral.gatt.disconnect();
      this.emit(DeviceEvent.DISCONNECTED);
    }
  }

}

const createWebBluetoothDevice = {
  create: (config) => {
    return new WebBluetoothDevice(config.blue.name, {
      serviceUUIDs: config.blue.serviceUUIDs, characteristicUUIDs: config.blue.characteristicUUIDs
    });
  },
  isSupport() {
    try {
      return "bluetooth" in navigator;
    } catch (e) {
      return false;
    }
  },
  canConnect: (config, device) => {
    return config.blue.name === device.name;
  }
};

export {
  WebBluetoothDevice, createWebBluetoothDevice
};